import CarrierAddEditModel from '../carrieraddeditmodel-dialog-screen.vue';
import CarrierImportModel from './carrier-items-import-screen.vue';

export default {
    data: function () {
        return {
            title: "Carriers",
            loading: false,
            channelSettings: {
                SenderId: 0,
                SenderName: "",
                SenderCode: ""
            },
            columns: [
                {
                    name: 'Id',
                    label: 'Id',
                    align: 'left',
                    field: row => row.Id,
                    sortable: false,
                    style: '',
                },
                {
                    name: 'SenderId',
                    label: 'SenderId',
                    align: 'left',
                    field: row => row.SenderId,
                    sortable: false,
                    style: '',

                },
                {
                    name: 'SenderCode',
                    label: 'Canonical',
                    align: 'left',
                    field: row => row.SenderCode,
                    sortable: true,
                    style: '',
                },
                {
                    name: 'Value1',
                    label: 'Carrier',
                    align: 'left',
                    field: row => row.Value1,
                    sortable: false,
                    style: ''
                },
                {
                    name: 'Value2',
                    label: 'Service',
                    align: 'left',
                    field: row => row.Value2,
                    sortable: false,
                    style: ''
                },
                {
                    name: 'Value3',
                    label: 'Mapping Direction',
                    align: 'left',
                    field: row => row.Value3,
                    sortable: false,
                    style: '',
                },
                {
                    name: 'Value4',
                    label: 'Carrier Type',
                    align: 'left',
                    field: row => row.Value4,
                    sortable: false,
                    style: '',
                },
                {
                    name: 'Description',
                    label: 'Description',
                    align: 'left',
                    field: row => row.Description,
                    sortable: false,
                    style: '',
                },
                {
                    name: 'Actions',
                    label: 'Actions',
                    align: 'center',
                    field: row => row.Actions,
                    sortable: false,
                    style: ''
                },
            ],
            columnsVisible: [
                'SenderCode', 'CarrierService', 'Value1', 'Value2', 'Value3', 'Value4', 'Description', 
                'Actions'
            ],
            dataSource: [],
            editRowKey: null,
            filter: null,
            pagination: {
                sortBy: 'SenderCode',
                descending: false,
                page: 1,
                rowsPerPage: 15,
                rowsNumber: 0 // Need for 'QTable Request' event
            }
        }
    },

    methods: {
        onRequest(props) {
            this.onLoadListDataSource({
                page: props.pagination.page,
                pageSize: props.pagination.rowsPerPage,
                filter: props.filter,
                sortBy: props.pagination.sortBy,
                descending: props.pagination.descending,
            });
        },

        refreshScreen() {
            if (this.channelSettings.SenderId > 0) {
                this.title = 'Carriers - SENDER: ' +
                    this.channelSettings.SenderName;
                
                this.pagination.page = 1;

                this.pagination.page = 1;

                this.onRequest({
                    pagination: this.pagination,
                    filter: this.filter
                });
            } else {
                this.title = 'Carriers';
                this.dataSource = [];
            }
        },

        onCreateActionClick() {
            this.$q.dialog({
                component: CarrierAddEditModel,
                parent: this,
                actionLabel: 'Save',
                index: 0,
                modelId: 0,
                modelObject: {
                    id: 0,
                    senderId: this.channelSettings.SenderId
                },
                actionTitle: 'Create',
                editMode: true
            }).onOk((payload) => {
                this.dataSource.splice(0, 0, payload.model);
                this.pagination.rowsNumber = this.pagination.rowsNumber + 1;
            });
        },

        onImportActionClick() {
            this.$q.dialog({
                component: CarrierImportModel,
                parent: this,
                actionLabel: 'Import',
                index: 0,
                modelId: 0,
                modelObject: {
                    id: 0,
                    senderId: this.channelSettings.SenderId
                },
                title: 'Import Carriers',
                editMode: true
            }).onOk(() => {
                this.refreshScreen();
            });
        },

        async onExportActionClick() {
            try {
                this.loading = true;
                window.location.href = '/api/ui/carriers/' + this.channelSettings.SenderId + '/export';
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },

        onEditActionClick(rowKey, rowIndex, row) {
            this.$q.dialog({
                component: CarrierAddEditModel,
                parent: this,
                actionLabel: 'Save',
                index: rowIndex,
                modelId: rowKey,
                modelObject: row,
                actionTitle: 'Edit',
                editMode: true
            }).onOk((payload) => {
                var currentItemIndex = this.dataSource.map(e => { return e.Id; }).indexOf(rowKey);
                this.dataSource.splice(currentItemIndex, 1, payload.model);
            });
        },

        onDeleteActionClick(rowKey, rowIndex, row) {
            this.$q.dialog({
                title: 'Confirm',
                message: 'Are you sure?',
                cancel: true,
                persistent: true
            }).onOk(() => {
                if (this.onDeleteModelDataSource(rowKey, row)) {
                    var currentItemIndex = this.dataSource.map(e => { return e.Id; }).indexOf(rowKey);
                    this.dataSource.splice(currentItemIndex, 1);
                    this.pagination.rowsNumber = this.pagination.rowsNumber - 1;
                }
            });
        },

        async onLoadListDataSource(params) {
            try {
                this.loading = true;

                let startRow = (params.page - 1) * params.pageSize;
                let fetchCount = params.pageSize;

                let requestBody = {
                    Skip: startRow,
                    Take: fetchCount + 1,
                    Filter: params.filter,
                    OrderBy: params.sortBy ? params.sortBy : 'Id',
                    OrderByDescending: params.descending
                };

                let response = await this.$http.post('/api/ui/carriers/bySalesChannel/' + this.channelSettings.SenderId, requestBody);
                let listViewDataSource = response.body;

                this.dataSource.splice(0, this.dataSource.length, ...listViewDataSource.Rows);
                
                this.pagination.page = params.page;
                this.pagination.rowsPerPage = params.pageSize;
                this.pagination.sortBy = params.sortBy;
                this.pagination.descending = params.descending;

                if (listViewDataSource.TotalRows) {
                    this.pagination.rowsNumber = listViewDataSource.TotalRows;
                }
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },

        async onDeleteModelDataSource(id, params) {
            try {
                this.loading = true;

                let url = this.$prepareServerUrl('/api/ui/carriers/{id}', id, params);
                let response = await this.$http.delete(url);
                this.$processServerJsonResponse(response.body, this.refreshScreen);
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },
    },

    watch: {
        channelSettings: 'refreshScreen'
    }
}